import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-etablissement-layout',
  templateUrl: './etablissement-layout.component.html',
  styleUrl: './etablissement-layout.component.scss'
})
export class EtablissementLayoutComponent implements OnInit{



  constructor() {
  }
  ngOnInit() {

  }
}
